// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyPolicy_wrapper_wBnl7"};